export const scrollEffect = () => {
  let scrollPosition = 0;
  let headerVisible = true;
  const headerElement = document.querySelector(
    "[data-js-menu=hide-on-scroll]"
  ) as HTMLElement;

  const isMobile = () => window.innerWidth < 1200;

  const focusWithinMenuOrMenuOpen = () => {
    if (isMobile()) {
      return headerElement?.dataset.mobileMenuOpen === "true";
    } else {
      return headerElement?.parentElement?.contains(document.activeElement);
    }
  };

  const toggleSecondaryNavigationOnScroll = () => {
    if (!headerElement) {
      return;
    }

    const currentScrollPosition = window.scrollY;
    if (currentScrollPosition < scrollPosition) {
      // up
      if (!headerVisible) {
        headerVisible = true;
        headerElement.style.transform = "";
        document.body.style.setProperty(
          "--header-height",
          `${headerElement.clientHeight}px`
        );
      }
    } else {
      // down
      if (currentScrollPosition > 200 && headerVisible) {
        if (!focusWithinMenuOrMenuOpen()) {
          headerVisible = false;
          headerElement.style.transform = `translateY(-100%)`;
          document.body.style.setProperty("--header-height", "0px");
        }
      }
    }

    scrollPosition = currentScrollPosition;
  };

  headerElement?.addEventListener("focusin", () => {
    if (!headerVisible) {
      // un-hide header on focus in
      headerElement.style.transform = "";
    }
  });

  setTimeout(
    () =>
      window.addEventListener("scroll", toggleSecondaryNavigationOnScroll, {
        passive: true,
      }),
    1000
  );
};
